import { render, staticRenderFns } from "./Assortment.vue?vue&type=template&id=ab00149e"
import script from "./Assortment.vue?vue&type=script&lang=js"
export * from "./Assortment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports